import { http } from "@di";
import actions from "./actions";
import repositories from "./repositories";
import presenters from "./presenters";
import useCases from "./useCases";
const cRepositorires = repositories(http);
const cUseCases = useCases(cRepositorires);
const cActions = actions();
const cPresenters = presenters(cUseCases, cActions);
export default {
    search: cPresenters.search,
};
